import React, {useCallback, useContext, useRef, useState} from "react"
import Menu, {MenuItem} from "@amzn/meridian/menu";
import Button from "@amzn/meridian/button"
import Icon from "@amzn/meridian/icon";
import menuTokens from "@amzn/meridian-tokens/base/icon/menu-meatball";
import {FormattedMessage} from "react-intl";
import {DepartContext} from "./context/DepartContext";
import useCapabilityContext from "../global/context/useCapabilityContext";
import {DepartFilterContext} from "./context/DepartFilterContext";

/**
 * This mehtod will handle route Status update event
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const RouteContextMenu = (props) => {
    const iconRef = useRef()
    const [open, setOpen] = useState(false)
    const onClickButton = useCallback(() => setOpen(true), [])
    const onClose = useCallback(() => setOpen(false), [])
    const {configViewModel, configDispatch} = useCapabilityContext();
    const { dispatch} = useContext(DepartContext);
    const {viewModelF, dispatchF} = useContext(DepartFilterContext)
    const getMenuItem = () => {
        const markReadyForDispatch = {title: "contextMenu.ready_to_depart", message:"MARK READY TO DEPART"};
        const menuItem = [];
        menuItem.push(markReadyForDispatch);
        return menuItem;
    };
    const executeAction = () => {
        dispatch({
            type: 'UPDATE_ROUTE_STATUS',
            data: {
                dispatcher: dispatch,
                filterDispatcher: dispatchF,
                routeId: props.route.routeId,
                baseUrl: configViewModel.baseUrl,
                stationConfig: configViewModel.stationConfig,
                configDispatch: configDispatch,
                xptNodes: viewModelF.xptNodes
            }
        });
    }


    return (
        <React.Fragment>
            <Button type="icon" ref={iconRef} onClick={onClickButton} size="small">
                <Icon tokens={menuTokens}>Settings</Icon>
            </Button>
            <Menu anchorNode={iconRef.current}
                  open={open}
                  position="right"
                  onClose={onClose}>
                {getMenuItem().map((menu, key) => (
                    <MenuItem key={key} onClick={() => executeAction()}>
                        <FormattedMessage id={menu.title} defaultMessage={menu.message}/>
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    )
}

export default RouteContextMenu


// WEBPACK FOOTER //
// ./src/components/depart/RouteContextMenu.js